<script setup>
const router = useRouter()
const route = useRoute()
const user = useStrapiUser()
const { getProviderAuthenticationUrl, logout } = useStrapiAuth()

const navbar = ref()
const { isFullscreen, enter, exit, toggle } = useFullscreen(navbar)

const onlineStats = useState('onlinePresenceStats', () => ({
  global: 0,
  anime: null,
  episode: null
}))

const loginWithDiscord = () => {
  useCookie('redirect', { path: '/' }).value = route.fullPath
  // Провайдера читає /auth/callback — з /live можна зайти ще й через Twitch
  useCookie('auth_provider', { path: '/' }).value = 'discord'
  window.location.href = getProviderAuthenticationUrl('discord')
}
</script>

<template>
  <div
    v-if="!isFullscreen"
    class="z-[20] relative bg-base-300/50"
  >
    <header
      ref="navbar"
      class="mx-auto max-w-[1350px] navbar"
    >
      <div class="navbar-start">
        <NuxtLink
          class="relative flex items-center gap-[10px] text-xl normal-case btn btn-ghost"
          to="/"
        >
          <div class="relative">
            <NuxtImg
              src="/icons/favicon.png"
              class="rounded-full overflow-hidden"
              width="36"
              height="36"
              alt="logo"
            />
            <div
              v-if="onlineStats.global > 0"
              class="top-0 right-[-10px] z-20 absolute flex items-center gap-[3px] bg-neutral/80 shadow-lg px-[5px] py-[1px] rounded-md font-medium text-[11px] text-neutral-content lg:text-[14px] leading-none"
              title="Зараз на сайті"
            >
              <span class="relative flex w-[8px] h-[8px]">
                <span
                  class="inline-flex absolute bg-success opacity-75 rounded-full w-full h-full"
                ></span>
                <span
                  class="inline-flex relative bg-success rounded-full w-[8px] h-[8px]"
                ></span>
              </span>
              {{ onlineStats.global }}
            </div>
          </div>

          <div class="hidden lg:block mb-[3px] text-sm lg:text-lg">
            {{ $t('title') }}
          </div>
        </NuxtLink>
      </div>
      <div class="navbar-end">
        <!-- <div class="dropdown">
          <label
            tabindex="0"
            class="btn btn-ghost btn-circle"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              aria-hidden="true"
              role="img"
              class="iconify iconify--ic"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M19.5 12c0-.23-.01-.45-.03-.68l1.86-1.41c.4-.3.51-.86.26-1.3l-1.87-3.23a.987.987 0 0 0-1.25-.42l-2.15.91c-.37-.26-.76-.49-1.17-.68l-.29-2.31c-.06-.5-.49-.88-.99-.88h-3.73c-.51 0-.94.38-1 .88l-.29 2.31c-.41.19-.8.42-1.17.68l-2.15-.91c-.46-.2-1-.02-1.25.42L2.41 8.62c-.25.44-.14.99.26 1.3l1.86 1.41a7.343 7.343 0 0 0 0 1.35l-1.86 1.41c-.4.3-.51.86-.26 1.3l1.87 3.23c.25.44.79.62 1.25.42l2.15-.91c.37.26.76.49 1.17.68l.29 2.31c.06.5.49.88.99.88h3.73c.5 0 .93-.38.99-.88l.29-2.31c.41-.19.8-.42 1.17-.68l2.15.91c.46.2 1 .02 1.25-.42l1.87-3.23c.25-.44.14-.99-.26-1.3l-1.86-1.41c.03-.23.04-.45.04-.68zm-7.46 3.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5z"
              ></path>
            </svg>
          </label>
          <ul
            tabindex="0"
            class="flex gap-3 bg-neutral shadow mt-3 p-3 rounded-box dropdown-content"
          >
            <SettingsSelectTheme />
            <SettingsSelectLang />
          </ul>
        </div> -->
        <NuxtLink
          to="/downloads"
          class="btn btn-ghost btn-circle"
          title="Завантажені епізоди"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"
            />
          </svg>
        </NuxtLink>
        <a
          href="https://base.monobank.ua/olsior#subscriptions"
          target="_blank"
          class="flex items-center gap-[10px] uppercase btn btn-ghost"
        >
          <img
            class="bg-neutral rounded-full w-[36px] h-[36px]"
            src="/mono.svg"
            alt=""
          />
          <span> Монобанк </span>
        </a>
        <div class="relative dropdown dropdown-end">
          <label
            tabindex="0"
            class="btn btn-ghost btn-circle"
          >
            <svg
              v-if="!user"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE -->
              <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88a9.95 9.95 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20"
              />
            </svg>
            <div
              v-else
              class="flex justify-center items-center bg-neutral rounded-full w-[36px] h-[36px] text-lg"
              :title="user.privat ? 'МОНОСаб' : 'Звичайний'"
            >
              {{ user.username.slice(0, 1) }}
              <img
                v-if="user?.privat"
                class="right-0 bottom-0 absolute w-[24px] h-[24px]"
                src="/sub.png"
                alt=""
              />
            </div>
          </label>
          <div
            tabindex="0"
            class="flex flex-col gap-1 bg-neutral shadow mt-2 p-2 rounded-box dropdown-content"
          >
            <!-- Прямий ефір — окрема сторінка з плеєром і чатом Twitch -->
            <!--
              Свідомо <a>, а не NuxtLink: потрібне повне перезавантаження.
              Клієнтський перехід на /live тягне за собою свої проблеми зі
              стилями й ініціалізацією плеєра, а сторінка все одно окрема —
              з власним layout і без спільного з каталогом стану
            -->
            <a
              class="flex flex-nowrap flex-shrink-0 gap-2 whitespace-nowrap btn btn-sm"
              href="/live"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m-5.5 2c0 1.93.9 3.65 2.3 4.77l-1.06 1.06A7.98 7.98 0 0 1 5 12c0-2.37 1.03-4.5 2.67-5.96l1.06 1.06A6.48 6.48 0 0 0 6.5 12m11 0c0-1.93-.9-3.65-2.3-4.77l1.06-1.06A7.98 7.98 0 0 1 19 12a7.98 7.98 0 0 1-2.74 6.03l-1.06-1.06A6.48 6.48 0 0 0 17.5 12M3.5 12c0 2.9 1.38 5.47 3.5 7.11l-1.06 1.06A10.47 10.47 0 0 1 2 12c0-3.32 1.54-6.28 3.94-8.21L7 4.85A8.98 8.98 0 0 0 3.5 12m17 0a8.98 8.98 0 0 0-3.5-7.15l1.06-1.06A10.47 10.47 0 0 1 22 12c0 3.32-1.54 6.28-3.94 8.21L17 19.15c2.12-1.64 3.5-4.21 3.5-7.15"
                />
              </svg>
              Прямий ефір
            </a>

            <!-- Кліпи з ефірів і записів — дивитись можна всім, і гостям теж -->
            <NuxtLink
              class="flex flex-nowrap flex-shrink-0 gap-2 whitespace-nowrap btn btn-sm"
              to="/clips"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle
                  cx="6"
                  cy="6"
                  r="3"
                />
                <circle
                  cx="6"
                  cy="18"
                  r="3"
                />
                <path d="M20 4 8.12 15.88M14.47 14.48 20 20M8.12 8.12 12 12" />
              </svg>
              Кліпи
            </NuxtLink>

            <!-- Записи ефірів цілком (закриті записи показують замок) -->
            <NuxtLink
              class="flex flex-nowrap flex-shrink-0 gap-2 whitespace-nowrap btn btn-sm"
              to="/archive"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect
                  x="2"
                  y="4"
                  width="20"
                  height="5"
                  rx="1"
                />
                <path d="M4 9v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9M10 13h4" />
              </svg>
              Архів
            </NuxtLink>

            <!-- Історія коментарів з усього сайту — потрібна всім, і гостям теж -->
            <NuxtLink
              class="flex flex-nowrap flex-shrink-0 gap-2 whitespace-nowrap btn btn-sm"
              to="/comments"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
              >
                <!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE -->
                <path
                  fill="currentColor"
                  d="M15.85 8.14c.39 0 .77.03 1.14.08C16.31 5.25 13.19 3 9.44 3c-4.25 0-7.7 2.88-7.7 6.43c0 2.05 1.15 3.86 2.94 5.04L3.67 16.5l2.76-1.19c.59.21 1.21.38 1.87.47c-.09-.39-.14-.79-.14-1.21c-.01-3.54 3.44-6.43 7.69-6.43M12 5.89a.96.96 0 1 1 0 1.92a.96.96 0 0 1 0-1.92M6.87 7.82a.96.96 0 1 1 0-1.92a.96.96 0 0 1 0 1.92"
                />
                <path
                  fill="currentColor"
                  d="M22.26 14.57c0-2.84-2.87-5.14-6.41-5.14s-6.41 2.3-6.41 5.14s2.87 5.14 6.41 5.14c.58 0 1.14-.08 1.67-.2L20.98 21l-1.2-2.4c1.5-.94 2.48-2.38 2.48-4.03m-8.34-.32a.96.96 0 1 1 .96-.96c.01.53-.43.96-.96.96m3.85 0a.96.96 0 1 1 0-1.92a.96.96 0 0 1 0 1.92"
                />
              </svg>
              {{ $t('comments') }}
            </NuxtLink>

            <div
              v-if="user"
              class="flex flex-col gap-1"
            >
              <!-- Профіль: акаунти, історія переглядів, коментарі й кліпи -->
              <NuxtLink
                class="flex flex-nowrap gap-2 whitespace-nowrap btn btn-sm"
                to="/profile"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M12 12a5 5 0 1 0-5-5a5 5 0 0 0 5 5m0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5"
                  />
                </svg>
                {{ user.username }} -
                {{ user.privat ? 'МОНОСаб' : 'Звичайний' }}
              </NuxtLink>
              <NuxtLink
                class="flex flex-nowrap flex-shrink-0 gap-2 whitespace-nowrap btn btn-sm"
                to="/login"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 14 14"
                >
                  <!-- Icon from Streamline by Streamline - https://creativecommons.org/licenses/by/4.0/ -->
                  <circle
                    cx="7"
                    cy="7"
                    r="6.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5.5 5.5A1.5 1.5 0 1 1 7 7v1"
                  />
                  <path
                    fill="currentColor"
                    d="M7 9.5a.75.75 0 1 0 .75.75A.76.76 0 0 0 7 9.5Z"
                  />
                </svg>
                Підписка на Монобанк
              </NuxtLink>
              <button
                class="btn btn-sm"
                @click="logout"
              >
                {{ $t('logout') }}
              </button>
            </div>

            <div
              v-else
              class="flex flex-col gap-1"
            >
              <NuxtLink
                class="flex flex-nowrap flex-shrink-0 gap-2 whitespace-nowrap btn btn-sm"
                to="/login"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 14 14"
                >
                  <!-- Icon from Streamline by Streamline - https://creativecommons.org/licenses/by/4.0/ -->
                  <circle
                    cx="7"
                    cy="7"
                    r="6.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5.5 5.5A1.5 1.5 0 1 1 7 7v1"
                  />
                  <path
                    fill="currentColor"
                    d="M7 9.5a.75.75 0 1 0 .75.75A.76.76 0 0 0 7 9.5Z"
                  />
                </svg>
                Підписка на Монобанк
              </NuxtLink>

              <button
                class="flex flex-nowrap flex-shrink-0 gap-2 whitespace-nowrap btn btn-sm"
                @click="loginWithDiscord"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19.27 5.33C17.94 4.71 16.5 4.26 15 4a.1.1 0 0 0-.07.03c-.18.33-.39.76-.53 1.09a16.1 16.1 0 0 0-4.8 0c-.14-.34-.35-.76-.54-1.09c-.01-.02-.04-.03-.07-.03c-1.5.26-2.93.71-4.27 1.33c-.01 0-.02.01-.03.02c-2.72 4.07-3.47 8.03-3.1 11.95c0 .02.01.04.03.05c1.8 1.32 3.53 2.12 5.24 2.65c.03.01.06 0 .07-.02c.4-.55.76-1.13 1.07-1.74c.02-.04 0-.08-.04-.09c-.57-.22-1.11-.48-1.64-.78c-.04-.02-.04-.08-.01-.11c.11-.08.22-.17.33-.25c.02-.02.05-.02.07-.01c3.44 1.57 7.15 1.57 10.55 0c.02-.01.05-.01.07.01c.11.09.22.17.33.26c.04.03.04.09-.01.11c-.52.31-1.07.56-1.64.78c-.04.01-.05.06-.04.09c.32.61.68 1.19 1.07 1.74c.03.01.06.02.09.01c1.72-.53 3.45-1.33 5.25-2.65c.02-.01.03-.03.03-.05c.44-4.53-.73-8.46-3.1-11.95c-.01-.01-.02-.02-.04-.02M8.52 14.91c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.84 2.12-1.89 2.12m6.97 0c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.83 2.12-1.89 2.12"
                  />
                </svg>
                <span> {{ $t('loginDiscord') }} </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
